<script>
    import { user_data } from './stores.js';
    import { onMount } from "svelte";
    import Chipscompnent from './components/chipscompnent.svelte';
    import Iqtemplate from "./components/iqtemplate.svelte";
    import {link, location, push, pop, replace} from 'svelte-spa-router';
    

    onMount(async() => {

    });

</script>

<Iqtemplate>
    <div class="cszinputcontainer">
        <div class="cszinputfieldcontainer">
            <div class="progresstext">5.1/6</div>
            <div class="csztopcopy">
                What type of home do you own?
            </div>
            <Chipscompnent
            chipsdata={ [
        {s: true, t: "Single Family", i:"/img/House.svg", cbf:()=>{$user_data.propertytype = "Single Family"}, n: "#/qualify"},
        {s: false, t: "Condo", i:"/img/Condo.svg", cbf:()=>{$user_data.propertytype = "Condo"}, n: "#/qualify"},
        {s: false, t: "Multi-unit", i:"/img/Multi-Unit.svg", cbf:()=>{$user_data.propertytype = "Multi-unit"}, n: "#/qualify"},
            ] }
            />

            <div class="progressbuttonholder">
                <button  on:click={()=>{push("#/first_time_home_owner");}} class="backbutton"><span class="backarrowcontainer"><img src="/img/triangle-left-arrow.svg" alt="back arrow" /></span>Go Back</button>
            </div>

        </div>
    </div>

</Iqtemplate>

<style>

</style>